import { Grid, Icon, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { SelectValidator, TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useNavigate, useParams } from "react-router-dom";
import { DocumentFormatEnum } from "../../_common/enum/documentFormat.enum";
import { EventDocumentUserRoleEnum } from "../../_common/enum/eventDocumentUserRole.enum";
import { IEventDocumentManage } from "../../_common/models/eventDocument/eventDocumentManage.model";
import { PrimaryButton } from "../../_components/button/primary.button";
import { toastr } from "../../_components/toastr/toastr";
import { eventDocumentService } from "../../_services/eventDocument.service";
import { handleErrorResponse, handleErrorResponseAxios } from "../../_helpers/handleResponse.helper";
import { tokenService } from "../../_services/token.service";
import { API_URL } from "../../_config/config.const";
import { accountService } from "../../_services/accounts.service";

export function EventDocumentUpload(params: {
    emitOnSave: () => void,
}) {

    const [isSaving, setIsSaving] = useState(false);
    const [isLoading, setLoading] = useState(false);
    let navigate = useNavigate();

    const { eventDocumentTemplateId, eventId } = useParams<{ eventDocumentTemplateId: string, eventId: string }>();
    const _eventDocumentTemplateId = Number(eventDocumentTemplateId || 0);
    const _eventId = Number(eventId || 0);

    const [eventDocuments, setEventDocuments] = useState<Array<IEventDocumentManage>>([]);

    useEffect(() => {
        if (_eventDocumentTemplateId > 0 || _eventId > 0) fetchData();

    }, [_eventDocumentTemplateId, _eventId]);

    function fetchData() {
        setLoading(true);
        return eventDocumentService
            .getAll(_eventId, _eventDocumentTemplateId)
            .then(
                (json) => {
                    setEventDocuments(json)
                }
            )
            .finally(() => setLoading(false));
    }

    function submit(e: any, index: number) {
        e.preventDefault();
        setIsSaving(true);

        const formData = new FormData();

        if (!eventDocuments || !eventDocuments.length)
            return;

        var d = eventDocuments[index];

        formData.append(`item.id`, (d.id || 0).toString());
        var fileInputField = document.getElementById("uploadUrl_" + index);
        if ((fileInputField as any) && (fileInputField as any)?.files && (fileInputField as any)?.files.length) {
            console.log((fileInputField as any).files[0]);
            formData.append(`item.file`, (fileInputField as any)?.files[0]);
        }

        return eventDocumentService
            .eventManage(formData)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    fetchData();

                }, handleErrorResponseAxios
            )
            .finally(() => setIsSaving(false));
    }

    function handleChange(event: any, index: number) {
        setEventDocuments((_eventDocuments) => {
            let ___eventDocuments = [..._eventDocuments];
            ___eventDocuments[index][event.target.name] = event.target.value;
            return ___eventDocuments;
        })
    };

    return (


        <>
            {(eventDocuments && eventDocuments.length > 0) && eventDocuments.map((eventDocument: any, index: number) =>
                <ValidatorForm onSubmit={(e) => submit(e, index)} noValidate>
                    <Grid container spacing={1}>

                        <Grid item xs={2}>
                            <TextValidator
                                label="Step"
                                value={eventDocument.step}
                                defaultValue={index + 1}
                                name="step"
                                key={"step_" + index}
                                fullWidth
                                disabled
                                onChange={(event) => { handleChange(event, index) }}
                                variant="filled"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <TextValidator
                                label="Name"
                                value={eventDocument.name}
                                name="name"
                                key={"name_" + index}
                                required
                                fullWidth
                                disabled
                                validators={['required']}
                                errorMessages={['This field is required']}
                                onChange={(event) => { handleChange(event, index) }}
                                variant="filled"
                                InputLabelProps={{
                                    shrink: !!eventDocument.name,
                                }}
                            />
                        </Grid>

                        <Grid item xs={3}>

                            <SelectValidator
                                value={eventDocument.eventDocumentUserRoleId}
                                onChange={(event) => { handleChange(event, index) }}
                                required
                                label="Role"
                                name="eventDocumentUserRoleId"
                                fullWidth
                                disabled
                                key={"eventDocumentUserRoleId_" + index}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                variant="filled"
                                InputLabelProps={{
                                    shrink: !!eventDocument.eventDocumentUserRoleId,
                                }}>

                                <MenuItem value={EventDocumentUserRoleEnum.Staff.toString()}>{EventDocumentUserRoleEnum[EventDocumentUserRoleEnum.Staff]}</MenuItem>
                                <MenuItem value={EventDocumentUserRoleEnum.Organiser.toString()}>{EventDocumentUserRoleEnum[EventDocumentUserRoleEnum.Organiser]}</MenuItem>

                            </SelectValidator>
                        </Grid>

                        <Grid item xs={3}>
                            <SelectValidator
                                value={eventDocument.documentFormatId}
                                onChange={(event) => { handleChange(event, index) }}
                                required
                                label="Type"
                                name="documentFormatId"
                                fullWidth
                                disabled
                                key={"documentFormatId_" + index}
                                validators={['required']}
                                errorMessages={['This field is required']}
                                variant="filled"
                                InputLabelProps={{
                                    shrink: !!eventDocument.documentFormatId,
                                }}>

                                <MenuItem value={DocumentFormatEnum.Any.toString()}>{DocumentFormatEnum[DocumentFormatEnum.Any]}</MenuItem>
                                <MenuItem value={DocumentFormatEnum.Image.toString()}>{DocumentFormatEnum[DocumentFormatEnum.Image]}</MenuItem>

                            </SelectValidator>
                        </Grid>
                        {(!eventDocument.uploadUrl || (index == 0 || (eventDocuments[index - 1].uploadUrl && accountService.isAdmin))) &&
                            <Grid item xs={6}>

                                <TextValidator
                                    label="Document Upload"
                                    value={eventDocument._uploadUrl}
                                    name="_uploadUrl"
                                    type="file"
                                    key={"uploadUrl_" + index}
                                    id={"uploadUrl_" + index}
                                    fullWidth
                                    required
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                    disabled={(index > 0 && !eventDocuments[index - 1].uploadUrl) || (accountService.isOrganiser && eventDocuments[index]?.eventDocumentUserRoleId === EventDocumentUserRoleEnum.Staff)}
                                    onChange={(event) => { handleChange(event, index) }}
                                    variant="filled"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Grid>
                        }

                        <Grid item xs={6}>
                            {eventDocument.downloadTemplateUrl &&
                                <PrimaryButton
                                    styles={{ "height": "100%" }}
                                    type="button"
                                    variant="success"
                                    onClick={() => {
                                        tokenService.GetReportToken().then((data) => {
                                            return window.open(API_URL + "/eventDocument/getDownload/?token=" + data + "&fileId=" + eventDocument.downloadTemplateUrl, "_blank");
                                        });
                                    }}>
                                    <Icon>download</Icon> Download Template
                                </PrimaryButton>
                            }
                        </Grid>

                        {eventDocument.uploadUrl &&
                            <Grid item xs={6}>
                                <PrimaryButton
                                    styles={{ "height": "100%" }}
                                    type="button"
                                    variant="info"
                                    onClick={() => {
                                        tokenService.GetReportToken().then((data) => {
                                            return window.open(API_URL + "/eventDocument/getUpload/?token=" + data + "&fileId=" + eventDocument.uploadUrl, "_blank");
                                        });
                                    }}>
                                    <Icon>download</Icon> Uploaded Document
                                </PrimaryButton>
                            </Grid>
                        }



                        {((!(index > 0 && !eventDocuments[index - 1].uploadUrl) && !eventDocument.uploadUrl) || (index == 0 || (eventDocuments[index - 1].uploadUrl && accountService.isAdmin))) &&
                            <Grid item xs={12} spacing={2}>
                                <PrimaryButton isLoading={isLoading} isSaving={isSaving} type="submit" variant="save">Save</PrimaryButton>
                            </Grid>
                        }

                        {index < (eventDocuments.length - 1) &&
                            <Grid item xs={12}>
                                <hr />

                            </Grid>
                        }
                    </Grid >

                </ValidatorForm >
            )
            }
        </>

    );
}